/// <reference path="../../../../typings/index.d.ts" />

module Meevo {
    'use strict';

    interface IMenuScope {
        subMenuItems: any[];
    }

    declare var screenfull: any;

    class MenuController implements IMenuScope {
        menuItems: IMenuItem[];
        rootScope: ng.IRootScopeService;
        mdSidenav: ng.material.ISidenavService;
        subMenuItems: IMenuItem[];
        menuService: MenuService;
        state: ng.ui.IStateService;
        sce: ng.ISCEService;

        static $inject = [
            "meevo.menuService", "$rootScope", "$state", "$mdSidenav", "meevo.components.common.DataService",
            "meevo.components.common.IdentityService", "$window", "meevo.components.modal.ModalService",
            'meevo.AppSettings', '$sce'
        ];

        constructor(
            menuService: Meevo.MenuService,
            $rootScope: ng.IRootScopeService,
            $state: ng.ui.IStateService,
            $mdSidenav: ng.material.ISidenavService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected $window: angular.IWindowService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $sce: ng.ISCEService,
            private url: string
        ) {
            this.state = $state;
            this.menuService = menuService;


            // Store the scope
            var vm = this;
            vm.menuItems = menuService.menuItems;
            vm.mdSidenav = $mdSidenav;
            vm.rootScope = $rootScope;
            vm.sce = $sce;

            vm.rootScope.$on(Meevo.Components.Common.Messages.SUB_MENU_SHOW,
                (event, data) => {
                    this.subMenuItems = data;

                    _.forEach(this.subMenuItems,
                        (menuItem: any) => {
                            if (menuItem.isNewWindow && menuItem.urlApi) {
                                this.getUrl(menuItem.urlApi).then((url) => {
                                    menuItem.newWindowUrl = url;
                                });
                            }
                        });
                });

            //throws error when popping up custom modal.
            //hotkey appears to still be deactived on menu close
            $mdSidenav('left', true)
                .then((instance) => {
                    instance.onClose(() => this.menuService.deactivateMenuShortCutGroup());
                });

            this.rootScope.$on(Meevo.Components.Common.Messages.SUB_MENU_SHORT_CUT_CLICK,
                (event: angular.IAngularEvent, menuItem: IMenuItem) => {
                    this.onMenuItemSelected(menuItem);
                })
        }

        onMenuItemSelected(subMenuItem: IMenuItem, clickEvent = null): void {

            if (clickEvent) {
                clickEvent.stopPropagation();
                clickEvent.preventDefault();
            }

            if (subMenuItem.isDisabled) return;

            if (subMenuItem.notMobileFriendly && device.mobile()) {
                this.modalService.alert("LABEL_NOT_AVAILABLE_ON_MOBILE");
                return;
            }
            //IE interprets invalid translation key. Eval menuitem on ID
            if (subMenuItem.id == 'community-site') {
                var communityUrl = 'https://speak.millenniumsi.com';

                this.dataService.customMethodData(this.appSettings.API_ROOT + '/' + 'MeevoStore/CommunityLink', 'GET', null, { 'LinkType': LinkType.SalesForceCommunity }).then(data => {
                    //var url;
                    //if (data && data.data && data.data.link) {
                    //    url = data.data.link;
                    //} else {
                    //    url = communityUrl;
                    //}
                    //let options: Meevo.Components.Modal.IModalOptions = {
                    //    templateUrl: "app/components/menu/iframeModalTemplate.html",
                    //    controller: "meevo.components.modal.MenuModalController",
                    //    controllerAs: 'vm',
                    //    bindToController: true,
                    //    locals: {
                    //        url: url
                    //    }
                    //};

                    if (data && data.data && data.data.link) {
                        this.$window.open(data.data.link, '_blank');
                    } else {
                        this.$window.open(communityUrl, '_blank');
                    }

                });
                return;
            }

            //IE interprets invalid translation key. Eval menuitem on ID
            if (subMenuItem.id == 'meevo-academy') {
                var academyUrl = 'https://speak.millenniumsi.com/s/education/';

                this.dataService.customMethodData(this.appSettings.API_ROOT + '/' + 'MeevoStore/CommunityLink', 'GET', null, { 'LinkType': LinkType.MillenniumAcademy }).then(data => {

                    //var url;
                    //if (data && data.data && data.data.link) {
                    //    url = data.data.link;
                    //} else {
                    //    url = academyUrl;
                    //}
                    //let options: Meevo.Components.Modal.IModalOptions = {
                    //    templateUrl: "app/components/menu/iframeModalTemplate.html",
                    //    controller: "meevo.components.modal.MenuModalController",
                    //    controllerAs: 'vm',
                    //    bindToController: true,
                    //    locals: {
                    //        url: url
                    //    }
                    //};
                    //this.modalService.showCustom(options);

                    if (data && data.data && data.data.link) {
                        this.$window.open(data.data.link, '_blank');
                    } else {
                        this.$window.open(academyUrl, '_blank');
                    }

                });
                return;
            }
            //IE interprets invalid translation key. Eval menuitem on ID
            if (subMenuItem.id == 'ideas_portal') {
                var ideasPortalUrl = 'https://speak.millenniumsi.com/idp/login?app=0spU0000000Kyqk';

                this.dataService.customMethodData(this.appSettings.API_ROOT + '/' + 'MeevoStore/CommunityLink', 'GET', null, { 'LinkType': LinkType.IdeaStartUrl }).then(data => {
                  if (data && data.data && data.data.link) {
                        this.$window.open(data.data.link, '_blank');
                    } else {
                      this.$window.open(ideasPortalUrl, '_blank');
                    }

                });
                return;
            }
            //IE interprets invalid translation key. Eval menuitem on ID
            if (subMenuItem.id == 'meevo-help'  ) {
                // Should open 1 out of 3 URLs depending on your location
                var url = this.menuService.openMeevoHelp();
                let options: Meevo.Components.Modal.IModalOptions = {
                    templateUrl: "app/components/menu/iframeModalTemplate.html",
                    controller: "meevo.components.modal.MenuModalController",
                    controllerAs: 'vm',
                    bindToController: true,
                    locals: {
                        url: url
                    }
                };
                //this.modalService.showCustom(options);
                return;
            }

            if (subMenuItem.id == "knowledge-articles") {
                var knowledgeArticlesUrl = 'https://millenniumsi--uat.sandbox.my.site.com/MeevoAcademy/s/';

                this.dataService.customMethodData(this.appSettings.API_ROOT + '/' + 'MeevoStore/CommunityLink', 'GET', null, { 'LinkType': LinkType.KnowledgeArticles }).then(data => {


                    if (data && data.data && data.data.link) {
                        this.$window.open(data.data.link, '_blank');
                    } else {
                        this.$window.open(knowledgeArticlesUrl, '_blank');
                    }

                });
                return;
            }

            if (subMenuItem.id === 'smart-center') {
                this.setSmartCenter();
            }

            if (subMenuItem.isNewWindow) {
                this.$window.open(subMenuItem.newWindowUrl, '_blank');
                return;
            }

            if (typeof subMenuItem.isNewWindowPromise === 'function') {
                subMenuItem
                    .isNewWindowPromise()
                    .then((url) => {
                        this.$window.open(url, '_blank');
                    });

                return;
            }

            if (_.has(subMenuItem, 'navigationType') && subMenuItem.navigationType === MenuNavigationType.Convo) {
                this.rootScope.$broadcast(Meevo.Components.Common.Messages.CONVO_REQUESTED,
                    subMenuItem.navigationTarget);
            } else {
                if (subMenuItem.id == 'walkin-kiosk') {
                    if (screenfull.isEnabled) {
                        var result = this.detectIE();
                        if (result === false) {
                            screenfull.request();
                        } else {
                            screenfull.request(angular.element(document.body)[0]);
                        }
                    }
                }

                this.rootScope.$broadcast(Meevo.Components.Common.Messages.MENU_ITEM_SELECTED,
                    subMenuItem.stateName, subMenuItem.stateParams || null);
            }
        }



        closeMenu(): void {
            this.rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_MENU);
        }

        getUrl(url): ng.IPromise<any> {
            return this.dataService.getItem(url);
        }

        detectIE(): any {
            var ua = window.navigator.userAgent;

            // Test values; Uncomment to check result �

            // IE 10
            // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

            // IE 11
            // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

            // Edge 12 (Spartan)
            // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

            // Edge 13
            // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

            var msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                // IE 10 or older => return version number
                return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            }

            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                var rv = ua.indexOf('rv:');
                return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
            }

            var edge = ua.indexOf('Edge/');
            if (edge > 0) {
                // Edge (IE 12+) => return version number
                return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
            }

            // other browser
            return false;
        }

        openMeevoHelp() {
            return this.menuService.openMeevoHelp();
        }

        setSmartCenter(): void {
            const context: IContext = this.state.get('home') as any;

            if (context) {
                context.isHomeContext = false;
                context.title = 'HERO_SUB_SMARTCENTER';
                context.reloadOnSearch = true;
            }

            angular.element(document).ready(function () {
                const backgroundElem: HTMLElement = document.getElementById('default-background');
                const smartCenterElem: HTMLElement = document.getElementById('smart-center-content');

                if (smartCenterElem && backgroundElem) {
                    smartCenterElem.setAttribute('style', 'display: ');
                    backgroundElem.setAttribute('style', 'display: none');
                }
            });

            // enable tab close buttons.
            let nodeList = document.getElementsByClassName('meevo-context-close');

            for (let i = 0; i < nodeList.length; i++) {
                const elem = nodeList[i];

                elem.setAttribute('style', 'display: ');
            }
        }
    }
    angular.module('meevo')
        .controller('MenuController', MenuController);
}
